import { LitElement, html } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { connect } from '../core/connect';
import { withProduct } from '../core/resolveProperties';
import { makeBenefitMessagesSelector } from '../core/selectors';

export class BenefitMessages extends withProduct(LitElement) {
  static get properties() {
    return {
      ...super.properties,
      messages: { type: Array, attribute: false }
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    if (!this.messages?.length) return html``;
    // Messages are expected to be pre-sanitized by SSPC, so we can safely render them as HTML.
    return html`
      <ul class="og-benefit-messages">
        ${this.messages.map(
          msg => html`
            <li>${unsafeHTML(msg)}</li>
          `
        )}
      </ul>
    `;
  }
}

export const mapStateToProps = (state, ownProps) => makeBenefitMessagesSelector(ownProps?.product)(state);

export const ConnectedBenefitMessages = connect(mapStateToProps)(BenefitMessages);

export default ConnectedBenefitMessages;
